module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.show) ? _c('div', {
    ref: "dof-cover",
    staticClass: "g-cover weex-ct weex-div",
    style: (_vm._px2rem(_vm.coverStyle, 75)),
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.clickCover($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show && _vm.buttons.length) ? _c('div', {
    ref: "dof-popover",
    staticClass: "g-popover weex-ct weex-div",
    style: (_vm._px2rem(_vm.contentStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    class: ['u-popover-arrow', _vm.theme !== 'white' && 'u-popover-theme-dark'],
    style: (_vm._px2rem(_vm.arrowStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }), _vm._v(" "), _c('scroller', {
    ref: "dof-inner-popover",
    class: ['u-popover-inner', _vm.theme !== 'white' && 'u-popover-theme-dark'],
    style: (_vm._px2rem(_vm.popoverInnerStyle, 75)),
    attrs: {
      "show-scrollbar": "false"
    }
  }, _vm._l((_vm.buttons), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: " weex-ct weex-div",
      class: [
        'i-btn',
        i === _vm.buttons.length - 1 ? 'i-btn-noborder' : '',
        _vm.layoutDirection == 'row' ? 'row-layout' : 'column-layout',
        _vm.layoutDirection == 'row' && i != _vm.buttons.length - 1 ? 'borderRight' : '',
        _vm.layoutDirection == 'column' && i != _vm.buttons.length - 1 ? 'borderBottom' : ''
      ],
      attrs: {
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.dofButtonClicked(i, item.key)
        }
      }
    }, [(item.icon && !_vm._isColmo) ? _c('figure', {
      staticClass: "btn-icon weex-el weex-image",
      attrs: {
        "src": item.icon,
        "data-img-src": item.icon,
        "weex-type": "image"
      }
    }) : _vm._e(), _vm._v(" "), (item.icon && _vm._isColmo) ? _c('dof-iconfont', {
      attrs: {
        "code": item.icon,
        "size": 56,
        "color": _vm.textStyle.color ? _vm.textStyle.color : 'rgba(255,255,255,0.80)',
        "data-evt-dofIconFontClicked": ""
      },
      on: {
        "dofIconFontClicked": function($event) {
          return _vm.dofButtonClicked(i, item.key)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: " weex-el weex-text",
      class: ['btn-text', _vm.theme !== 'white' && 'btn-text-theme-dark'],
      style: (_vm._processExclusiveStyle(_vm.textStyle, 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.text))])], 1)
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.show && !_vm.buttons.length) ? _c('div', {
    ref: "dof-popover",
    staticClass: "g-popover weex-ct weex-div",
    style: (_vm._px2rem(_vm.contentStyle, 75)),
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return (function () {})($event)
      }
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    class: ['u-popover-arrow', _vm.theme !== 'white' && 'u-popover-theme-dark'],
    style: (_vm._px2rem(_vm.arrowStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }), _vm._v(" "), _c('div', {
    ref: "dof-inner-popover",
    staticClass: "content-inner weex-ct weex-div",
    style: (_vm._px2rem(_vm.innerContentStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("default", [_c('p', {
    staticClass: "textContent weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.textStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.textContent))]), _vm._v(" "), _vm._t("icon", [(_vm.isShowClose) ? _c('div', {
    staticClass: "closeBox weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.$emit('clickedCloseBtn')
      }
    }
  }, [(!_vm._isColmo) ? _c('figure', {
    staticClass: "closeIcon weex-el weex-image",
    attrs: {
      "src": _vm._isDiablo ? _vm.imgs.closeDiablo : _vm.imgs.close,
      "data-img-src": _vm._isDiablo ? _vm.imgs.closeDiablo : _vm.imgs.close,
      "weex-type": "image"
    }
  }) : _c('dof-iconfont', {
    attrs: {
      "code": '\u4725',
      "size": 32,
      "color": _vm._isColmo ? 'rgba(255,255,255,0.80)' : '#1E2E37',
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": function($event) {
        return _vm.$emit('clickedCloseBtn')
      }
    }
  })], 1) : _vm._e()], {})], {})], 2)]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-70015f30", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70015f30","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-popover2/index.vue
// module id = 635
// module chunks = 0 1